require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./legalized-marijuana-juveniles.json") })
        }
      }, "path---legalized-marijuana-juveniles");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---legalized-marijuana-juveniles!./.cache/json/legalized-marijuana-juveniles.json
// module id = 925
// module chunks = 231608221292675